export default {
	list: [],
	history: {
		list: []
	},
	pending: {
		list: []
	},
	filter: {
		date: '',
		student: ''
	}
};



// WEBPACK FOOTER //
// ./sources/app/medicine/state.js